var _path, _ellipse, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 271,
    viewBox: "0 0 24 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19L12 270",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9997,
    cy: 12.1538,
    rx: 5.99967,
    ry: 5.23683,
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.35952 0 11.9699C0 14.5728 0.8555 16.9613 2.2775 18.9174C2.303 18.9643 2.307 19.0167 2.336 19.0615L10.336 31.0314C10.707 31.5865 11.332 31.9197 12 31.9197C12.668 31.9197 13.293 31.5865 13.664 31.0314L21.664 19.0615C21.6935 19.0167 21.697 18.9643 21.7225 18.9174C23.1445 16.9613 24 14.5728 24 11.9699C24 5.35952 18.627 0 12 0ZM12 15.9599C9.791 15.9599 8 14.1733 8 11.9699C8 9.76643 9.791 7.97993 12 7.97993C14.209 7.97993 16 9.76643 16 11.9699C16 14.1733 14.209 15.9599 12 15.9599Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.e9a61cff6dc9ecb91fbcc7e4cb8e6bc6.svg";
export { ForwardRef as ReactComponent };